
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { TOptions } from 'smartbarcode-web-core/src/utils/types/index'
import { objectToArray } from 'smartbarcode-web-core/src/utils/helpers'

@Options({
  name: 'InputRadio',
  emits: ['update:modelValue'],
  inheritAttrs: false,
})
export default class InputRadio extends Vue {
  @Prop({ type: String }) readonly modelValue?: string
  @Prop({ type: Object }) readonly selections!: TOptions
  @Prop({ type: String }) readonly name!: string
  @Prop({ type: String }) readonly fieldName?: string = ''
  @Prop({ type: Boolean }) readonly isDisplayedDropdownList?: boolean = true

  get options() {
    return objectToArray(this.selections)
  }

  get value() {
    return this.modelValue ?? {}
  }

  set value(newVal) {
    this.$emit('update:modelValue', newVal)
  }

  get isDisplayedDropdown() {
    return this.isDisplayedDropdownList
  }
}
